import liveboardFromJs from 'models/liveboards/liveboard_from_js';

export default {
  fromDto(dto, liveboardType) {
    return liveboardFromJs({ ...dto, type: liveboardType });
  },
};
